import React, { useEffect, useState } from 'react';
import app from 'services/firebase';
import { connect } from 'react-redux';
import { getChannels } from 'features/messages/components/ducks/messagesActions';
import { getTrainer } from 'features/trainer/profile/ducks/trainerProfileActions';

export const AuthContext = React.createContext();

const AuthProvider = props => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    app.auth().onAuthStateChanged(user => {
      setCurrentUser(user);
      setLoading(false);
      user && props.getTrainer(user.uid);
      user && props.getChannels();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, isLoading }}>
      {props.children}
    </AuthContext.Provider>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getTrainer: trainerUid => dispatch(getTrainer(trainerUid)),
    getChannels: () => dispatch(getChannels())
  };
}

export default connect(null, mapDispatchToProps)(AuthProvider);
